import { useQuery } from "@tanstack/react-query";
import { Department, DepartmentService } from "../../../services/department-viags/department.service";
import { TreeDataNode } from "antd";
import { useMemo } from "react";

export const useDepartment = () => {
  const departmentCode = "";
  const { data, isLoading, isError } = useQuery({
    queryKey: ["department", departmentCode],
    queryFn: () => DepartmentService.getDepartmentListV5(departmentCode),
  });

  const treeData: TreeDataNode[] = useMemo(() => {
    const mapToTreeDataNode = (item: Department): TreeDataNode => ({
      key: item.code,
      title: item.name,
      children: item.viagsDepartmentChild?.map(mapToTreeDataNode) || [],
    });

    if (!data) return [];
    return data.map(mapToTreeDataNode);
  }, [data]);

  return { data, isLoading, isError, treeData };
};
